import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import * as z from "zod";
// import {
//   Form,
//   FormControl,
//   FormField,
//   FormItem,
//   FormMessage,
// } from '@/components/ui/form';
// import { Input } from '@/components/ui/input';
// import { Button } from '@/components/ui/button';
// import { StateSelector } from './StateSelector';
// import { BoardSelector } from './BoardSelector';
// import { ClassSelector } from './ClassSelector';
// import { LanguagePreferenceSelector } from './LanguagePreferenceSelector';
// import { useToast } from '@/hooks/use-toast';
import { Button } from "@/shared/components/ui/button";
import {
  PersonalizationFormData,
  PreferredLanguage,
} from "../types/auth.types";
import { BoardSelector } from "./BoardSelector";
import { StateSelector } from "./StateSelector";
import { ClassSelector } from "./ClassSelector";
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormMessage,
} from "@/shared/components/ui/form";
import { Input } from "@/shared/components/ui/input";
import { LanguageToggle } from "./LanguageToggle";
// import { personalizationService } from '@/lib/personalization';
// import { PersonalizationFormData, PreferredLanguage } from '@/types/personalization';
// import { supabase } from '@/lib/supabase';

interface PersonalizationFormProps {
  onSuccess?: (preferences: PersonalizationFormData) => void;
  initialData?: PersonalizationFormData;
}

const formSchema = z.object({
  fullName: z.string().min(2, "Name must be at least 2 characters").max(100),
  stateId: z.string().min(1, "State is required"),
  boardId: z.string().min(1, "Board is required"),
  classId: z.string().min(1, "Class is required"),
  preferredLanguage: z.enum(["en", "hi"]),
});

export const PersonalizationForm: React.FC<PersonalizationFormProps> = ({
  initialData,
}) => {
  //   const { toast } = useToast();
  const [isLoading] = useState(false);

  const form = useForm<PersonalizationFormData>({
    resolver: zodResolver(formSchema),
    defaultValues: initialData || {
      fullName: "",
      stateId: "",
      boardId: "",
      classId: "",
      preferredLanguage: "en",
    },
  });

  const onSubmit = async (_data: PersonalizationFormData) => {
    // setIsLoading(true);
    // try {
    //   const user = await supabase.auth.getUser();
    //   if (!user.data.user) {
    //     throw new Error('User not authenticated');
    //   }
    //   const userId = user.data.user.id;
    //   const existingPreferences = await personalizationService.getUserPreferences(userId);
    //   if (existingPreferences) {
    //     await personalizationService.updateUserPreferences(userId, data);
    //     toast({
    //       title: 'Success',
    //       description: 'Learning preferences updated successfully!',
    //     });
    //   } else {
    //     await personalizationService.createUserPreferences(userId, data);
    //     toast({
    //       title: 'Success',
    //       description: 'Learning preferences saved successfully!',
    //     });
    //   }
    //   onSuccess?.(data);
    // } catch (error: unknown) {
    //   console.error('Error saving preferences:', error);
    //   const errorMessage = error instanceof Error ? error.message : 'Failed to save preferences';
    //   toast({
    //     title: 'Error',
    //     description: errorMessage,
    //     variant: 'destructive',
    //   });
    // } finally {
    //   setIsLoading(false);
    // }
  };

  return (
    <Form {...form}>
      <form onSubmit={form.handleSubmit(onSubmit)} className="space-y-6 w-full">
        <FormField
          control={form.control}
          name="fullName"
          render={({ field }) => (
            <FormItem>
              <FormControl>
                <Input
                  {...field}
                  placeholder="Your Name"
                  className="input-auth"
                  disabled={isLoading}
                />
              </FormControl>
              <FormMessage className="text-red-200 text-sm mt-1" />
            </FormItem>
          )}
        />

        <FormField
          control={form.control}
          name="stateId"
          render={({ field }) => (
            <FormItem>
              <FormControl>
                <StateSelector
                  value={field.value}
                  onChange={field.onChange}
                  disabled={isLoading}
                  error={form.formState.errors.stateId?.message}
                />
              </FormControl>
            </FormItem>
          )}
        />

        <FormField
          control={form.control}
          name="boardId"
          render={({ field }) => (
            <FormItem>
              <FormControl>
                <BoardSelector
                  value={field.value}
                  onChange={field.onChange}
                  disabled={isLoading}
                  error={form.formState.errors.boardId?.message}
                />
              </FormControl>
            </FormItem>
          )}
        />

        <FormField
          control={form.control}
          name="classId"
          render={({ field }) => (
            <FormItem>
              <FormControl>
                <ClassSelector
                  value={field.value}
                  onChange={field.onChange}
                  disabled={isLoading}
                  error={form.formState.errors.classId?.message}
                />
              </FormControl>
            </FormItem>
          )}
        />

        <FormField
          control={form.control}
          name="preferredLanguage"
          render={({ field }) => (
            <FormItem>
              <FormControl>
                {/* <LanguagePreferenceSelector
                  value={field.value as PreferredLanguage}
                  onChange={field.onChange}
                  disabled={isLoading}
                /> */}
                <div>
                  <label className="text-white/80 text-sm font-medium">
                    Preferred Language
                  </label>
                  <LanguageToggle
                    value={field.value as PreferredLanguage}
                    onChange={field.onChange}
                    disabled={isLoading}
                    className=""
                  />
                </div>
              </FormControl>
            </FormItem>
          )}
        />

        <Button
          type="submit"
          className="w-full h-16 bg-white text-blue-600 hover:bg-gray-100 rounded-2xl text-lg font-semibold transition-all shadow-lg"
          disabled={isLoading}
        >
          {isLoading ? "Saving..." : "Continue"}
        </Button>
      </form>
    </Form>
  );
};
